import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, IconButton } from '@mui/material';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import { MtComStyleObj } from '../styles/MtComStyleObj';
interface CommentDialogProps {
    open: boolean;
    onClose: () => void;
    onSave: () => void;
    commentText: string;
    onCommentTextChange: (text: string) => void;
    stepName: string;
    originalCommentText: string;
}


export const CommentDialog = ({
    open,
    onClose,
    onSave,
    commentText,
    onCommentTextChange,
    stepName,
    originalCommentText
}: CommentDialogProps) => {
    
    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    p: 1
                }
            }}
        >
            <DialogTitle sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1.5,
                pb: 2
            }}>
                <ChatBubbleOutlineIcon sx={{ color: '#1976d2', fontSize: '1.625rem' }} />
                <Typography variant="h6" sx={{ flex: 1, fontWeight: 600, fontSize: '1.2rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    Add Comment
                </Typography>
                <IconButton 
                    onClick={onClose}
                    size="small"
                    sx={{ 
                        color: '#666',
                        '&:hover': { backgroundColor: '#f5f5f5' }
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ pb: 2 }}>
                <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 600, color: '#333', fontSize: '1.1375rem' }}>
                    Step:
                </Typography>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, fontSize: '1.2rem' }}>
                    {stepName}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 600, color: '#333', fontSize: '1.1375rem' }}>
                    Comment
                </Typography>
                <TextField
                    autoFocus
                    fullWidth
                    multiline
                    rows={4}
                    placeholder="Enter your comment about this step..."
                    value={commentText}
                    onChange={(e) => onCommentTextChange(e.target.value)}
                    variant="outlined"
                     sx={(theme) => ({
                         ...MtComStyleObj(theme).textBoxValueStyle, 
                        '& .MuiOutlinedInput-root': {
                            borderRadius: 2,
                            backgroundColor: '#fafafa',
                            '& fieldset': {
                                borderColor: '#e0e0e0'
                            },
                            '&:hover fieldset': {
                                borderColor: '#bdbdbd'
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#1976d2'
                            }
                        }
                   })}
                />
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2.5, gap: 1.5, flexDirection: { xs: 'column', sm: 'row' } }}>
                <Button
                    onClick={onSave}
                    variant="contained"
                    disabled={!commentText.trim() || commentText === originalCommentText}
                    startIcon={<SendIcon />} disableRipple
                    sx={{
                        flex: 1,
                        width: { xs: '100%', sm: 'auto' },
                        textTransform: 'none',
                        fontWeight: 600,
                        py: 1.25,
                        fontSize: '1.1rem',
                        background: '#094BC7',
                        borderRadius: 2,
                        boxShadow: 'none',
                        color: '#fff',
                        '&:hover': {
                            background: '#073a9c',
                            boxShadow: 'none', border: 'none', outline: 'none'
                        },
                        '&:active': {
                            background: '#073a9c',
                            boxShadow: 'none', border: 'none', outline: 'none'
                        },
                        '&:focus': {
                            background: '#073a9c',
                            boxShadow: 'none', border: 'none', outline: 'none'
                        },
                        '&:disabled': {
                            background: '#e0e0e0',
                            color: '#9e9e9e'
                        }
                    }}
                >
                    Save Comment
                </Button>
                <Button
                    onClick={onClose}
                    variant="outlined"
                    disableRipple
                    sx={{
                        flex: 1,
                        width: { xs: '100%', sm: 'auto' },
                        textTransform: 'none',
                        fontWeight: 600,border: "1px solid #000000",
                        py: 1.25,
                        fontSize: '1.1rem',
                        color: '#666',
                        borderRadius: 2,
                        '&:hover': {
                            backgroundColor: 'white',
                            boxShadow: 'none',outline:"none",border: "1px solid #000000"
                        },
                        '&:active': {
                             backgroundColor: 'white',
                            boxShadow: 'none',outline:"none",border: "1px solid #000000"
                        },
                         '&:focus': {
                              backgroundColor: 'white',
                            boxShadow: 'none',outline:"none",border: "1px solid #000000"
                        },
                    }}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};
